let Fragment = require('@/shaders/blur/fragment.glsl');
import * as THREE from 'three';

export default class BlurShader {


    // SETUP -------------------------------------------------------------------

    constructor(options) {

        this.tweenObj = {
            amount: 0
        };
 
        this.tInput = options.tInput;
        this.renderer = options.renderer;
        this.config = options.config;
 
        this.setup();
    }

    setup() {

          this.scene = new THREE.Scene();

            var halfWidth = window.innerWidth * 0.5;
            var halfHeight = window.innerHeight * 0.5;
            this.camera = new THREE.OrthographicCamera(-halfWidth, halfWidth, halfHeight, -halfHeight, -100, 100);
            this.camera.position.set(0, 0, 0.001);

            this.tweenObj = {};

            this.container = new THREE.Group();
            this.clock = new THREE.Clock();

            this.textureA = new THREE.WebGLRenderTarget(window.innerWidth, window.innerHeight, {
                minFilter: THREE.LinearFilter,
                magFilter: THREE.LinearFilter
            });
            this.textureB = new THREE.WebGLRenderTarget(window.innerWidth, window.innerHeight, {
                minFilter: THREE.LinearFilter,
                magFilter: THREE.LinearFilter
            });

            this.material = new THREE.ShaderMaterial({
                uniforms: {
                    tBuffer: {
                        type: "t",
                        value: this.textureA.texture
                    },
                    tInput: {
                        type: "t",
                        value: this.tInput
                    }, 
                    res: {
                        type: 'v2',
                        value: new THREE.Vector2(window.innerWidth, window.innerHeight)
                    },
                    time: {
                        type: "f",
                        value: Math.random() * Math.PI * 2 + Math.PI
                    },
                    falloff: {
                        type: "f",
                        value: 1
                    },
                    speed: {
                        type: "f",
                        value: 1
                    },
                    mixAmt: {
                        type: "f",
                        value: 1
                    }
                }, 
                fragmentShader: Fragment
            });

            this.geometry = new THREE.PlaneGeometry(1, 1, 32);
            this.mesh = new THREE.Mesh(this.geometry, this.material);

            this.fbo = this.textureB;

            this.container.add(this.mesh);
            this.scene.add(this.container);
            this.update(1)
    }


    // UPDATES -------------------------------------------------------------------

    tick(mixAmt) {

        if( mixAmt < 1){
            this.update(mixAmt)
        }

    }

    update(mixAmt){

        this.renderer.render(this.scene, this.camera, this.fbo, true);

        //Swap textureA and B
        this.fbo = this.textureA;
        this.textureA = this.textureB;
        this.textureB = this.fbo;
        this.mesh.material.map = this.textureB.texture;
        this.material.uniforms.tBuffer.value = this.textureA;
        this.material.uniforms.mixAmt.value = mixAmt; 

        //Update time
        this.material.uniforms.time.value += 0.1;
    }

    resize() {

        let ww = window.innerWidth;
        let wh = window.innerHeight;

        if (this.fbo) {
            this.textureA.setSize(ww, wh);
            this.textureB.setSize(ww, wh);
        }

        if (this.camera) {
                this.camera.left = ww / -2;
                this.camera.right = ww / 2;
                this.camera.top = wh / 2;
                this.camera.bottom = wh / -2;
                this.camera.updateProjectionMatrix();
            }

            if (this.mesh) {
                this.mesh.scale.x = ww;
                this.mesh.scale.y = wh;
            }
 
    }

    updateOptions(config) {
        this.config = config;
    }
 

    close() {}


    // STATES -------------------------------------------------------------------


}

 